import { render, staticRenderFns } from "./DragNDrop.vue?vue&type=template&id=bdc2794e&"
import script from "./DragNDrop.vue?vue&type=script&lang=js&"
export * from "./DragNDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragNDrop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports